export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14743.0c94c5fd.jpg";